import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { SiteModel } from 'src/app/models/site.model';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from '../../../shared/rbac.service';
import { TagModel } from '../../../models/tag.model';

@Component({
  selector: 'app-sites-details-settings',
  templateUrl: './sites-details-settings.component.html',
  styleUrls: ['./sites-details-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesDetailsSettingsComponent implements OnInit {
  site: SiteModel = new SiteModel();

  inProgress: boolean = false;

  parent_id: number;
  child_id: number;
  site_id: number;

  after_hours_notification_duration_options: number[] = [
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75
  ]; // minutes

  sign_out_zone_radius_options: number[] = [0, 25, 50, 75, 100];

  constructor(
    private app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
    public rbac: RBACService
  ) {}

  ngOnInit(): void {
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      this.router.navigate(['/sites']);
      return;
    }

    // Get the site id from the route params.
    this.parent_id = Number(this.route.parent.snapshot.params['parent_id']);
    this.child_id = Number(this.route.parent.snapshot.params['child_id']);

    // Check if we are updating a site or creating a new one.
    if (
      this.child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        this.parent_id)
    ) {
      // Store the site id.
      this.site_id = this.child_id ? this.child_id : this.parent_id;

      this.api
        .makeRequest('get', `v1/sites/${this.site_id}`)
        .then(
          (response: any): void => {
            this.site.apply(response.data);

            // Extract Tag ids.
            this.site.tag_ids = this.site.tags
              ? this.site.tags.map((tag: TagModel): number => tag.id)
              : [];
          }
        )
        .catch(
          (errorResponse: any): void => {
            this.utils.showToast(
              'The ' +
                this.utils
                  .getLangTerm('parent-child-sites-combined.singular', 'Site')
                  .toLowerCase() +
                ' could not be found. Please try again.'
            );
            this.router.navigate(['sites']);
          }
        );
    } else {
      this.router.navigate(['/sites']);
      return;
    }
  }

  onSave(form: NgForm): void {
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      return;
    }

    if (!form.valid) {
      this.utils.showToast(
        'Please make sure you enter or select all required fields.'
      );
      return;
    }

    this.inProgress = true;

    this.api
      .makeRequest('put', `v1/sites/${this.site.id}`, this.site)
      .then(
        (response: any): void => {
          this.utils.showToast('The settings were updated successfully.');
        }
      )
      .finally(
        (): void => {
          this.inProgress = false;
        }
      );
  }
}
